import { render, staticRenderFns } from "./EmailDetailsContainer.vue?vue&type=template&id=3ed7cf22&scoped=true"
import script from "./EmailDetailsContainer.vue?vue&type=script&lang=js"
export * from "./EmailDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./EmailDetailsContainer.vue?vue&type=style&index=0&id=3ed7cf22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed7cf22",
  null
  
)

export default component.exports